import { styled } from "@mui/material/styles";
import Typography from "@mui/material/Typography";
import type { ResolutionIncomingAuthor } from "work/proposals/redlining/field-redlines/resolution-incoming-author";

const AuthorCaption = styled(Typography)(({ theme }) => ({
  display: "block",
  fontSize: "0.7rem",
  lineHeight: 1.3,
  fontStyle: "italic",
  color: theme.palette.text.secondary,
}));

export interface ResolutionTargetAuthorLabelProps {
  author?: ResolutionIncomingAuthor | null;
  /** Resolved display name for the incoming author, when available. */
  authorName?: string;
}

/**
 * Labels an in-field resolution target with who proposed the incoming ("theirs") value. A
 * resolution target is always a cross-party redline now — reviewer (intra-party) resolution
 * targets were retired (ROADMAP.md item 2; a reviewer's own-party edit surfaces via field change
 * history instead), so this label no longer distinguishes an origin.
 */
export default function ResolutionTargetAuthorLabel({
  author,
  authorName,
}: Readonly<ResolutionTargetAuthorLabelProps>) {
  if (!author) return null;

  const who = authorName?.trim() || "the other party";

  return (
    <AuthorCaption variant="caption" data-origin={author.origin}>
      Proposed by {who}
    </AuthorCaption>
  );
}
